import React from "react";

export default function AdminPanelGeneralHeading(props) {
  return (
    <div className="col-12 p-0">
      <h3
        className={`admin-panel-add-general-heading ${
          props.classes ? props.classes : "noPropsClass"
        } text-center text-md-start`}
      >
        {props.text}
      </h3>
    </div>
  );
}
